import * as React from "react";
import { useState, useCallback } from "react";
import UserNotification from "util/UserNotification";
import { Button } from "components/bootstrap";
import { ConfirmDialog, IfPermitted } from "components/common";
import { deleteDataLakeBackend } from "data-lake/data-lake-backend-config/hooks/useDataLakeBackendMutation";
const DeleteDataLakeAction = ({ backend, refetchDataLakeBackend }) => {
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const onDeleteSubmit = useCallback(() => {
    deleteDataLakeBackend(backend.id).then(() => {
    }).catch((error) => {
      UserNotification.error(`An error occurred while deleting Data Lake backend. ${error}`);
    }).finally(() => {
      setShowConfirmDelete(false);
      refetchDataLakeBackend();
    });
  }, [backend, refetchDataLakeBackend]);
  const onDelete = () => {
    setShowConfirmDelete(true);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "data_lake_backend_config:delete" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "danger", onClick: onDelete }, "Delete")), showConfirmDelete && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      title: `Deleting ${backend.title} Data Lake backend, are you sure?`,
      show: true,
      onConfirm: onDeleteSubmit,
      onCancel: () => setShowConfirmDelete(false)
    },
    /* @__PURE__ */ React.createElement("p", null, `You are about to remove ${backend.title} Data Lake backend. This action cannot be undone.`)
  ));
};
export default DeleteDataLakeAction;
